import { useContext, useState } from "react";
import { Context } from "../../../context/Context";
import { ActionMenu, Archive, CircleStop, Megaphone, Rocket, Trash2 } from "../../ui";
import { getCampaignText } from "./campaignActionsText";
import ActivateCampaignModal from "./ActivateCampaignModal";
import { CancelCampaignModal, DeleteCampaignModal, DeletedCampaignsModal } from "./CampaignFlowModals";

// Compact entry point for campaign work in Operations: one ActionMenu that
// opens the Activate, Cancel and Delete flows (plus the deleted list).
//   actions: limits the menu to these keys (default: all)
export default function CampaignActionsMenu({ stores, onChanged, actions }) {
  const { lang } = useContext(Context);
  const text = getCampaignText(lang);
  const [open, setOpen] = useState("");
  const close = () => setOpen("");

  const items = [
    { key: "activate", label: text.activateTitle, icon: <Rocket size={16} />, onClick: () => setOpen("activate") },
    { key: "cancel", label: text.cancelTitle, icon: <CircleStop size={16} />, onClick: () => setOpen("cancel") },
    { key: "delete", label: text.deleteTitle, icon: <Trash2 size={16} />, tone: "danger", onClick: () => setOpen("delete") },
    { key: "deleted", label: text.deletedTitle, icon: <Archive size={16} />, divider: true, onClick: () => setOpen("deleted") },
  ].filter((item) => !actions || actions.includes(item.key));

  return (
    <>
      <ActionMenu
        label={text.boxTitle}
        triggerLabel={text.boxTitle}
        icon={<Megaphone size={16} />}
        items={items}
        className="operation-campaign-menu"
      />
      {open === "activate" && <ActivateCampaignModal stores={stores} onClose={close} onDone={onChanged} />}
      {open === "cancel" && <CancelCampaignModal stores={stores} onClose={close} onDone={onChanged} />}
      {open === "delete" && <DeleteCampaignModal stores={stores} onClose={close} onDone={onChanged} />}
      {open === "deleted" && <DeletedCampaignsModal stores={stores} onClose={close} />}
    </>
  );
}
